export default __webpack_public_path__ + "static/media/info_icon.8f0da202.svg";